import axios from '@/api/axios';
import type {AdminPaginatedEnvelope, AfriexID, BusinessLimit} from '@/types';
const endpoint = '/v2/admin/limits';

// Business limits are a small, admin-curated set (the server caps at 1000), so
// callers pull the whole list once and filter/paginate it client-side.
const MAX_BUSINESS_LIMITS = 1000;

export const businessLimitService = {
  getBusinessLimitList: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<AdminPaginatedEnvelope<BusinessLimit[]>> => {
    const response = await axios.get<AdminPaginatedEnvelope<BusinessLimit[]>>(
      endpoint,
      {
        params: {page: 0, limit: MAX_BUSINESS_LIMITS, ...params},
      },
    );
    return response?.data;
  },
  createBusinessLimit: async (item: BusinessLimit): Promise<BusinessLimit> => {
    const response = await axios.post<BusinessLimit>(endpoint, item);
    return response?.data;
  },
  updateBusinessLimitById: async (
    id: AfriexID,
    item: BusinessLimit,
  ): Promise<BusinessLimit> => {
    const url = `${endpoint}/${id}`;
    const response = await axios.patch<BusinessLimit>(url, item);
    return response?.data;
  },
  removeBusinessLimitById: async (id: AfriexID): Promise<BusinessLimit> => {
    const url = `${endpoint}/${id}`;
    const response = await axios.delete<BusinessLimit>(url);
    return response?.data;
  },
};

export type BusinessLimitService = typeof businessLimitService;
